import { render } from "./credits-overview-dialog.vue?vue&type=template&id=34787938"
import script from "./credits-overview-dialog.vue?vue&type=script&lang=js"
export * from "./credits-overview-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-user-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__